import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesMax } from './ITypeValidatesMax';

export class MaxValidator implements ValidatorInterface<ITypeValidatesMax> {
  name = 'Max';

  friendlyName = 'Maximum Value';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.max.description';

  types = ['String', 'LongText', 'Percentage', 'Currency', 'Number'];

  properties = {
    value: {
      type: 'Number',
      default: 1,
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesMax) {
    type.addMaxValidator(this);
  }
}

const maxValidator = new MaxValidator(undefined);

ValidatorRegistry.register(MaxValidator, maxValidator.name);

export { maxValidator };
